import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

export const ChargerResumeContainer = styled.div`
  height: 100%;
`;
export const ResumeTitle = styled.div``;
export const ResumeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
export const ResumeContent = styled.div`
  > div {
    margin-top: ${pxToRem('15px')};
  }
`;
export const ResumeContentItem = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const Label = styled.div``;

const statusFunction = props => {
  let style;
  if (props.bulletStatus) {
    style = css`
      &::before {
        content: '';
        height: ${pxToRem('8px')};
        width: ${pxToRem('8px')};
        border-radius: 50%;
        background-color: ${({ theme, bulletStatus, statusColor }) =>
          (bulletStatus === 'charging'
            ? theme.colors.statusGreen
            : statusColor === 'stand-by'
            ? theme.colors.statusYellow
            : theme.colors.statusRed)};
        font-weight: bold;
        display: inline-block;
        margin-left: -1em;
        margin-right: ${pxToRem('10px')};
      }
    `;
    return style;
  }
  return style;
};

export const Item = styled.div`
  ${props => statusFunction(props)}
`;
export const IconsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: ${pxToRem('55px')};

  > div:not(:last-child)::after {
    content: '';
    display: inline-block;
    height: ${pxToRem('35px')};
    width: ${pxToRem('2px')};
    background-color: #dad7db;
    position: absolute;
    right: -${pxToRem('25px')};
  }
`;
